<template>
  <div>
    <div>
      <v-btn
        @click.stop="setDialog(true)"
        :alt-text="`Delete ${entityType}`"
        :disabled="disabled"
        color="primary"
        outlined
        small
        :title="`Delete ${entityType}`"
        >Delete
      </v-btn>
    </div>

    <v-dialog v-model="dialog" max-width="400" persistent>
      <delete-question-confirmation
        :entityType="entityType"
        :entityId="entityId"
        @setDialog="setDialog"
      ></delete-question-confirmation>
    </v-dialog>
  </div>
</template>

<script>
import DeleteQuestionConfirmation from "./DeleteQuestionConfirmation";

export default {
  components: { DeleteQuestionConfirmation },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    async setDialog(val) {
      if (val === true) {
        try {
          await this.$store.dispatch(`${this.entityType}/get`, this.entityId);
        } catch (e) {
          this.$notifyError({
            message: "Could not get item.",
          });
        }
      }
      this.dialog = val;
    },
  },
  props: ["disabled", "entityType", "entityId"],
};
</script>
